// This file should only contain action type constants.

// export const SET_FOO = 'SET_FOO';
export const SET_OPTIN_DATA = 'SET_OPTIN_DATA';
export const SET_DEALER_DATA = 'SET_DEALER_DATA';
export const SET_STORIES_DATA = 'SET_STORIES_DATA';
export const ADD_STORIES_DATA = 'ADD_STORIES_DATA';
export const SET_ACCOUNT_URL = 'SET_ACCOUNT_URL';
export const SET_DEALER_CODE = 'SET_DEALER_CODE';
export const SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME';
export const FIRE_TRACK_EVENT = 'FIRE_TRACK_EVENT';
